import React from 'react';
import Seo, { SITE } from '../components/Seo/Seo';
import UIUXHeroSection from '../components/UIUX/UIUXHeroSection';
import ProjectRequestSection from '../components/ProjectRequestSection/ProjectRequestSection';
import uiuxSkillsets from '../data/UIUX/UIUXSkillsetData';
import SkillsetSection from '../components/SkillSetSection/SkillsetSection';
import FAQSection from '../components/FAQSection/FAQSection';
import { uiuxFAQs, uiuxIntro } from '../data/UIUX/UIUXFAQ';
import ProjectSteps from '../components/ProjectSteps/ProjectSteps';
import uiuxSteps from '../data/UIUX/UIUXProjectSteps';
import ServiceSection from '../components/ServiceSection/ServiceSection';
import UIUXData from '../data/UIUX/UIUXServices';

const serviceJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'UI/UX Design',
  serviceType: 'UI Design, UX Design & Prototyping',
  description:
    'Nutzerzentriertes UI/UX-Design für Web und App: Research, Wireframes, Prototypen und barrierefreie Interfaces nach WCAG.',
  provider: { '@id': `${SITE.url}/#organization` },
  areaServed: ['Köln', 'Bonn', 'Deutschland'],
  url: `${SITE.url}/services/ui-ux-design`,
};

const UIUX = () => {
  return (
    <>
      <Seo
        title="UI/UX Design Agentur Köln | Interface & User Experience | Nexite IT"
        description="Nutzerzentriertes UI/UX-Design aus Köln: Wir gestalten intuitive Benutzeroberflächen und barrierefreie Nutzererlebnisse für Web und App – von Research bis Prototyping."
        path="/services/ui-ux-design"
        jsonLd={serviceJsonLd}
      />

      <UIUXHeroSection />
      <ServiceSection data={UIUXData} />
      <SkillsetSection
        skillsets={uiuxSkillsets}
        title="Design-Kompetenzen"
        subtitle="Wie wir Gestaltung und Nutzererlebnis zusammenbringen"
      />
      <ProjectSteps title="Unser UI/UX Design Prozess" steps={uiuxSteps} />
      <ProjectRequestSection />
      <FAQSection faqs={uiuxFAQs} intro={uiuxIntro} />
    </>
  );
};

export default UIUX;
